import React, { Component } from "react";
import moment from 'moment';
import CancelBooking from '../home/CancelBooking';
import ClassWorkoutVideo from '../home/ClassWorkoutVideo';
import { showMainErrorPop } from '../../actions/popups';
import { connect } from "react-redux";
import { bookmarkClass } from  '../../utils/bookmarkClass';
import InstructorInfo from '../home/InstructorInfo';

import axiosVirdioT from '../../utils/axios';
var axiosVirdio;

class LiveClassDetails extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={
		classBoking: false,
		sessionToCancel: 0,
		sessionData: {},
		isOpenActivity: true,
		isOpenEquipment: false,
		isOpenWorkoutVideo: false,
		videoURL: '',
		videoName: '',
		currentUserData: JSON.parse(localStorage.getItem('userData')),
		defaultJoinTime: localStorage.getItem('userData') ? parseInt(JSON.parse(localStorage.getItem('userData')).default.defaultSessionDuration) : 15,
		videoDescription: '',
		isOpenInstructorInfo: false,
		test: false,
		thisIsFalse: false
    }
	
	this.bookmarkClass = bookmarkClass.bind(this);
}
 
componentDidMount(){
	axiosVirdio = new axiosVirdioT(this.props);
	this.setState({
			sessionData: this.props.classInfo
		}, ()=>{  
			
			console.log('--------sessionData', this.state.sessionData);
			this.countdownTimer(); 
			});
}

updateClassDetails=(details)=>{
	this.setState({sessionData: details}, ()=>{
		if ( details && !details.sessionId)
			{
				var mainthis = this;
				setTimeout(function(){
					mainthis.props.closeDetails();
				}, 1000);
				
			}
		
	});
}

openCancel=(id)=>{
	this.setState({classBoking: true, sessionToCancel: id});
	if ( this.props && this.props.openCancelTrigger )
		{
			this.props.openCancelTrigger();
		}
	
}

updateStateFromChild=(state)=>{
	this.setState(state);

	if ( state['sessionToCancel'] === 0 )
		{
			this.props.closeCancelTrigger();
		}
}

cancelSessionStatus = (id)=>{
	this.setState({
		classBoking: false
	}, ()=>{ 
		let temp = this.props.classInfo;
		if ( temp.hostId == this.state.currentUserData.id )
			{
				this.props.closeDetails(id);
			}
		else
			{
				temp.bookingStatus = 4;
				this.updateStateFromChild({classInfo: temp});
				this.props.updateParent(id, 4);
			}	
	});
	this.checkPropsAgain();
	this.props.closeCancelTrigger();
}

bookSession = (id)=>{
	
	if ( this.props && this.props.failedPaymentStatus )
		{
			return false;	
		}

	var postData = {
		sessionId: id
	};
	let token = JSON.parse(localStorage.getItem('userData')).token;
    axiosVirdio.auth(token);	 
	axiosVirdio.post(process.env.REACT_APP_API_URL +'/api/v1/session/bookSessionMarketplace', postData).then(res => {
		let temp = this.props.classInfo;
		temp['bookingStatus'] = 0;
		this.updateStateFromChild({classInfo: temp});
		this.props.updateParent(id, 0);
		this.checkPropsAgain();
	}).catch(err =>{ 
		let msg = '';
		console.log('-------err-----', err);
		if ( err.response.data.errorData.message && err.response.data.errorData.message != '' )
			{
				msg = err.response.data.errorData.message;
			}
		this.props.showMainErrorPop(msg);
	});
}

checkPropsAgain=()=>{
	
	if ( this.props.fromMarketplaceLive )
		{
			this.props.reloadDetails();
		}
}

openCloseWorkout=()=>{
	var isOpenWorkout = this.state.isOpenActivity;
	isOpenWorkout = !isOpenWorkout;
	this.setState({isOpenActivity: isOpenWorkout});
}

openCloseEquipment=()=>{
	var isOpenEq = this.state.isOpenEquipment;
	isOpenEq = !isOpenEq;
	this.setState({isOpenEquipment: isOpenEq});
}

bookMarkClass=(item)=>{
	
	if ( this.props && this.props.failedPaymentStatus )
		{
			return false;	
		}
	
	var sessionDataState = this.state.sessionData;
	var statusClass = 1;
	if ( item.isBookmarked == 1 ) { statusClass = 0; }
	
	var mainthis = this;
	this.bookmarkClass(item.sessionId, 1, statusClass).then(function(res){
		sessionDataState.isBookmarked = statusClass;
		mainthis.setState({sessionData: sessionDataState});
		mainthis.props.getLiveClasses(true, true);
	}, function (err) { 
		if ( err.response && err.response.data && err.response.data.errorData ) 
			{
				mainthis.props.showMainErrorPop(err.response.data.errorData); 
			}
	});
}

playWorkVideo=(item)=>{
	this.setState({isOpenWorkoutVideo: true, videoURL: item.activityVideo, videoName: item.activityName, videoDescription: item.activityDescription})
}

countdownTimer() {
	let mainthis = this;
    var x = setInterval(function() {
			
			let temp = mainthis.state.sessionData;
			var timeRemaining = Math.floor((new Date(temp.scheduleDate).getTime() - new Date().getTime())/1000);
			temp['timeUntil'] = timeRemaining;
			mainthis.setState({
					sessionData: temp
				});
	}, 1000); 
  }
  
openClass=(id)=>{
	this.props.openClass(id);
}

openInstructorInfo=()=>{
	this.setState({
		isOpenInstructorInfo: true,
	});
}

  render() {
	 const sessionData = this.state.sessionData;
	 
	 return (
		
		
		<div className="details_content">
			{ sessionData && sessionData.sessionId &&
				<div>
					<div className="top_class_content">
						<div className="class_time">{moment(sessionData.scheduleDate).format('hh:mm A')}</div>
						<div className="class_dot">&bull;</div>
						<div className="class_time">{sessionData.sessionDuration} min</div>
						<div className="class_interest">{sessionData.interestTitles}</div>
						{sessionData.replayClassId > 0 &&  
							<div className="class_interest">Replay</div>
						}
					</div>
					<div className={"left_details_class " + ( sessionData.classWorkout && sessionData.classWorkout.length === 0 ? "full_left_details" : "" )}>
						<div className="details_class_name">{sessionData.sessionName}</div>
						<div className="class_description">{sessionData.sessionDescription}</div>
						{ ((sessionData.hostingSession && sessionData.hostingSession == 1) || sessionData.bookingStatus == 0 || sessionData.bookingStatus == 1 ) &&
							<div>
								{ sessionData.timeUntil < this.state.defaultJoinTime*60 ?
									<div>
										{ sessionData.timeUntil <= 0 ?
											<div className="classStarting">Class in progress</div>
											:
											<div className="classStarting">Class starts in <span>{(sessionData.timeUntil/60)>=10 ? Math.floor(sessionData.timeUntil/60) : '0'+Math.floor(sessionData.timeUntil/60)}</span> : <span>{(sessionData.timeUntil-Math.floor(sessionData.timeUntil/60)*60)>=10 ? (sessionData.timeUntil-Math.floor(sessionData.timeUntil/60)*60) : '0'+(sessionData.timeUntil-Math.floor(sessionData.timeUntil/60)*60)}</span></div>
										}
									</div>
									:
									<div className="classStarting">{sessionData.hostingSession && sessionData.hostingSession == 1 ? 'Hosting' : 'Booked'}</div>
								}
							</div>
						}
						<div className="detail_buttons_content">
							{ sessionData.hostingSession && sessionData.hostingSession == 1 ?
								<div className={"out_buttons " + (sessionData.timeUntil > this.state.defaultJoinTime*60 ? "chwidth0" : "")}>
									{ sessionData.timeUntil < this.state.defaultJoinTime*60 &&
										<div className="active_detail_btn2 details_button" onClick={() => this.openClass(sessionData.sessionId)}>
											<div className="detailsJoinButton">JOIN CLASS</div>
										</div>
									}
								</div>
								:
								<div className={"out_buttons " + (sessionData.bookingStatus == 3 ? "chwidth0" : "")}>
									{ (sessionData.bookingStatus == 0 || sessionData.bookingStatus == 1 ) ?
										<div>
											{ sessionData.timeUntil < this.state.defaultJoinTime*60 ?
												<div className="active_detail_btn2 details_button" onClick={() => this.openClass(sessionData.sessionId)}>JOIN CLASS</div>
												:
												<div className="active_detail_btn2 cancel_detail2 details_button" onClick={() => this.openCancel(sessionData.sessionId)}>Cancel</div>
											}
										</div>
										:
										<div>
											{ (sessionData.bookingStatus == null || sessionData.bookingStatus == 4 ) &&
												<div className="active_detail_btn2" details_button onClick={() => this.bookSession(sessionData.sessionId)}>Book</div>
											}
										</div>
									}
								</div>
							}
							<div className="inactive_detail_btn details_button" onClick={() => this.bookMarkClass(sessionData)}>
								<span>{sessionData.isBookmarked == 1 ? 'Bookmarked' : 'Bookmark'}
									<div className={"inactive_book " + ( sessionData.isBookmarked == 1 ? "bookmarked_details" : "" )}></div>
								</span>
							</div>
						</div>
						<div className="instructor_content_details">
							<div className="instructorInfoHolder" onClick={() => this.openInstructorInfo()} >
								<div className="instructor_avatar details_avatar" style={{ backgroundImage: sessionData.hostImage && sessionData.hostImage.indexOf('.s3') > -1 ? "url("+sessionData.hostImage+")" : "url(./images/user_avatar.svg)"}}></div>
								<div className="instructor_content_info">
									<div className="instructor_title">Instructor</div>
									<div className="instructor_name_details">{sessionData.hostFirstName} {sessionData.hostLastName}</div>
								</div>
							</div>
							<div className="instructor_text" dangerouslySetInnerHTML={{__html: sessionData.instructorText}}></div>
						</div>
						{ sessionData.musicType && sessionData.musicType !== "" &&
							<div className="session_content">
								<div className="session_content_icon music_icon"></div>
								<div className="session_content_info">
									<div className="session_content_sub">Music</div>
									<div className="session_content_title">{sessionData.musicType}</div>
								</div>
							</div>
						}
						{ sessionData.classHasVirtualEquipment == 1 &&
							<div>
								<div className="session_content">
									<div className="session_content_icon virtual_icon"></div>
									<div className="session_content_info">
										<div className="session_content_sub">Equipment</div>
										<div className="session_content_title">Virtual Equipment</div>
									</div>
								</div>
								<div className="virtual_content">
									<div className="one_virtual_content">
										<div className="virtual_content_title">Requirements</div>
										{ sessionData.virtualRequirements.map((req, i) =>
											<li className="virtual_content_info" key={i}>{req}</li>
										)}
									</div>
									<div className="one_virtual_content">
										<div className="virtual_content_title">Recommendations</div>
										{ sessionData.virtualRecommendations.map((rec, i) =>
											<li className="virtual_content_info" key={i}>{rec}</li>
										)}
									</div>
								</div>
							</div>
						}
					</div>
					{ ((sessionData.classWorkout && sessionData.classWorkout.length > 0) || (sessionData.classEquipment && sessionData.classEquipment.length > 0)) &&
						<div className="right_details_class">
							<div>
								{ sessionData.classWorkout && sessionData.classWorkout.length > 0 &&
									<div>
										<div className="workout_title workout_demand_title" onClick={this.openCloseWorkout}>Activity List
											<div className={"workout_arrow " + ( this.state.isOpenActivity ? "active_arrow" : "" )}></div>
										</div>
										{ this.state.isOpenActivity &&
											<div>
												{ sessionData.classWorkout.map((item, i) =>
													<div className="work_content" key={i}>
														<div className="work_name">{item.activityName}</div>
														{ item.activityDurationType === 'Time' &&
															<div className="work_duration">{item.activityDuration} Seconds</div>
														}
														{ item.activityDurationType === 'Reps' &&
															<div className="work_duration">{item.activityRepeatNum} sets <span>&bull;</span> {item.activityDuration} seconds</div>
														}
														{ item.activityVideo !== '' &&
															<div className="work_play" onClick={() => this.playWorkVideo(item)}></div>
														}
													</div>
												)}
											</div>
										}
									</div>
								}
							</div>
							<div>
								{ sessionData.classEquipment && sessionData.classEquipment.length > 0 &&
									<div>
										<div className="workout_title workout_demand_title" onClick={this.openCloseEquipment}>Recommended Equipment
											<div className={"workout_arrow " + ( this.state.isOpenEquipment ? "active_arrow" : "" )}></div>
										</div>
										{ this.state.isOpenEquipment &&
											<div>
												{ sessionData.classEquipment.map((item, i) =>
													<div className="work_content" key={i}>
														<div className="work_name">{item.equipment_name}</div>
													</div>
												)}
											</div>
										}
									</div>
								}
							</div>
						</div>
					}
				</div>
			}
			{ sessionData && !sessionData.sessionId &&
				<div className="empty_details">Class not available anymore.</div>
			}
			{ this.state.classBoking &&
				<CancelBooking updateStateFromChild={this.updateStateFromChild} sessionId={this.state.sessionToCancel} cancelSessionStatus={this.cancelSessionStatus}></CancelBooking>
			}
			{ this.state.isOpenWorkoutVideo &&
				<ClassWorkoutVideo videoURL={this.state.videoURL} videoName={this.state.videoName} videoDescription={this.state.videoDescription} updateStateFromChild={this.updateStateFromChild}></ClassWorkoutVideo>
			}
			{this.state.isOpenInstructorInfo &&
				<InstructorInfo sessionData={sessionData} updateStateFromChild={this.updateStateFromChild} ></InstructorInfo>
			}
		</div>
    );
  }
}

export default connect(
  null,
  { 
	showMainErrorPop
  },
  null,
  {forwardRef: true}
)(LiveClassDetails);
